import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { Box, Typography, FormControl, Select, MenuItem, TextField, FormControlLabel } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import { Switch, styled } from '@mui/material';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import userimg from '../../../assets/images/user_img.png'; // Import your static image
import VisibilityIcon from '@mui/icons-material/Visibility';

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: 'green',
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: 'red',
    opacity: 1,
  },
}));

const MyTable = () => {
  const [data, setData] = useState([
    {
      id: '1',
      image: userimg,
      orderId: 'ORD001',
      drivers: 'Vardhan Gandem',
      date: '2025-01-01',
      amount: 1000,
      orderStatus: 'Completed',
    },
    {
      id: '2',
      image: userimg,
      orderId: 'ORD002',
      drivers: 'Pratyaksh',
      date: '2025-02-01',
      amount: 1500,
      orderStatus: 'Pending',
    },
    {
      id: '3',
      image: userimg,
      orderId: 'ORD003',
      drivers: 'Nik',
      date: '2025-03-01',
      amount: 1200,
      orderStatus: 'Completed',
    },
    {
      id: '4',
      image: userimg,
      orderId: 'ORD004',
      drivers: 'Ananya Rao',
      date: '2025-04-10',
      amount: 800,
      orderStatus: 'Shipped',
    },
    {
      id: '5',
      image: userimg,
      orderId: 'ORD005',
      drivers: 'Arjun Mehta',
      date: '2025-05-15',
      amount: 1100,
      orderStatus: 'Completed',
    },
    {
      id: '6',
      image: userimg,
      orderId: 'ORD006',
      drivers: 'Aarav Patel',
      date: '2025-06-20',
      amount: 1400,
      orderStatus: 'Pending',
    },
  ]);

  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      const allIds = data.map(item => item.id);
      setSelectedRows(allIds);
    }
    setSelectAll(!selectAll);
  };

  const handleRowCheckboxChange = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter(id => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  const deleteItem = (itemId) => {
    alert('Order has been Deleted');
  };

  const navigate = useNavigate();

  const columns = [
    {
      name: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} checked={selectAll} onChange={handleSelectAll}>
          <Box>
            <input type="checkbox" />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', color: 'green' }}>
            <Delete
              sx={{
                cursor: 'pointer',
                padding: '0px',
                fontSize: '18px',
              }}
              onClick={() => alert('Delete all items action triggered!')}
            />
            <Typography variant="body1">All</Typography>
          </Box>
        </Box>
      ),
      selector: row => row.id,
      cell: (row) => (
        <input type="checkbox" checked={selectedRows.includes(row.id)} 
          onChange={() => handleRowCheckboxChange(row.id)} />
      ),
      sortable: false,
      style: {
        padding: '8px',
        textAlign: 'center',
      },
    },
    {
      name: 'Images',
      selector: row => row.image,
      cell: row => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={row.image}
            alt={row.itemName}
            style={{ width: 50, height: 50, objectFit: 'cover', marginRight: 8 }}
          />
        </Box>
      ),
      sortable: false,
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Order ID',
      selector: row => row.orderId,
      sortable: true,
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Drivers',
      selector: row => row.drivers,
      sortable: true,
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Date',
      selector: row => row.date,
      sortable: true,
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Amount',
      selector: row => row.amount,
      sortable: true,
      cell: row => (
        <Typography
          variant="body1"
          sx={{ color: 'green', fontWeight: '400' }} // Add green color styling
        >
          {row.amount}
        </Typography>
      ),
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Order Status',
      selector: row => row.orderStatus,
      sortable: true,
      style: {
        padding: '8px',
      },
    },
    {
      name: 'Actions',
      cell: row => (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <VisibilityIcon sx={{
              cursor: 'pointer',
              backgroundColor: '#E1E7E9',
              color: '#000',
              borderRadius: '50%',
              padding: '5px',
              fontSize: '28px',
            }}
            onClick={() => navigate(`view/${row.id}`)}/>
          <Edit
            sx={{
              cursor: 'pointer',
              backgroundColor: 'green',
              color: '#fff',
              borderRadius: '50%',
              padding: '5px',
              fontSize: '28px',
            }}
            onClick={() => navigate(`edit/${row.id}`)}
          />
          <Delete
            sx={{
              cursor: 'pointer',
              backgroundColor: 'red',
              color: '#fff',
              borderRadius: '50%',
              padding: '6px',
              fontSize: '28px',
            }}
            onClick={() => deleteItem(row.id)}
          />
        </Box>
      ),
      sortable: false,
      style: {
        padding: '8px',
      },
    },
  ];

  const filteredData = data.filter(item =>
    (item.orderId.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.drivers.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
     item.amount.toString().includes(searchTerm) ||
     item.orderStatus.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const startIndex = (page - 1) * entriesPerPage;
  const currentPageData = filteredData.slice(startIndex, startIndex + entriesPerPage);

  const handleEntriesChange = event => {
    setEntriesPerPage(event.target.value);
    setPage(1); // Reset page to 1 when changing entries per page
  };

  const handleSearchChange = event => {
    setSearchTerm(event.target.value);
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" sx={{ mr: 1 }}>
            Show
          </Typography>
          <FormControl sx={{ p: 1 }}>
            <Select
              value={entriesPerPage}
              onChange={handleEntriesChange}
              displayEmpty
              inputProps={{ 'aria-label': 'Entries per page' }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <Typography variant="body1" sx={{ mr: 1 }}>
            entries
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" sx={{ mr: 1 }}>
            Search:
          </Typography>
          <TextField
            className="recent-or-search-cls"
            id="outlined-basic"
            label=""
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            size="small"
          />
        </Box>
      </Box>

      <Box sx={{ border: '1px solid #dee2e6', borderRadius: '8px', overflow: 'hidden' }}>
        <DataTable
          columns={columns}
          data={currentPageData}
          pagination
          paginationServer
          paginationTotalRows={filteredData.length}
          onChangePage={newPage => setPage(newPage)}
          paginationPerPage={entriesPerPage}
          paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          customStyles={{
            table: {
              style: {
                tableLayout: 'auto',
              },
            },
            cells: {
              style: {
                padding: '8px',
                border: '1px solid #dee2e6',
                color: '#67757c',
                fontSize: '14px',
              },
            },
            headCells: {
              style: {
                backgroundColor: '#f4f4f4',
                fontWeight: 'bold',
                padding: '8px',
                border: '1px solid #dee2e6',
                fontSize: '1rem',
              },
            },
            rows: {
              style: {
                '&:hover': {
                  backgroundColor: '#f1f1f1',
                },
                '&:nth-child(odd)': {
                  boxShadow: 'inset 0 0 0 9999px rgba(0, 0, 0, 0.023)',
                },
              },
            },
          }}
        />
      </Box>
    </div>
  );
};

export default MyTable;
